module.exports = __webpack_public_path__ + "static/media/noun-coffee-2820266-808080.6a72be66.svg";